import { mergeStyles } from "@fluentui/react";
import { tokens } from "@fluentui/react-components";

export const browseContainerClass = mergeStyles({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  paddingBottom: 64,
});

export const treeContainerClass = mergeStyles({
  padding: "4px 0",
  overflow: "auto",
  overscrollBehaviorX: "contain",
  flex: 1,
  minHeight: 0,
  scrollbarGutter: "stable",
  "& [role='tree']": {
    display: "inline-block",
    minWidth: "100%",
  },
  "& [role='treeitem']": {
    display: "inline-flex",
    flexDirection: "column",
    minWidth: "100%",
  },
  "& .fui-TreeItemLayout": {
    minWidth: "max-content",
  },
});

export const treeItemLayoutClass = mergeStyles({
  cursor: "pointer",
  width: "max-content",
  "& .fui-TreeItemLayout__main": {
    overflow: "visible",
    textOverflow: "clip",
    whiteSpace: "nowrap",
    minWidth: "max-content",
  },
});

export const labelClass = mergeStyles({
  whiteSpace: "nowrap",
});

export const selectedLabelClass = mergeStyles({
  whiteSpace: "nowrap",
  fontWeight: "bold",
});

export const footerClass = mergeStyles({
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  padding: "8px 12px",
  borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
  backgroundColor: tokens.colorNeutralBackground1,
  display: "flex",
  justifyContent: "stretch",
  zIndex: 1,
});

export const fileButtonClass = mergeStyles({
  width: "100%",
});

export const searchStatusClass = mergeStyles({
  padding: "16px 12px",
  display: "flex",
  alignItems: "center",
  gap: 8,
});

export const searchBoxWrapperClass = mergeStyles({
  padding: "8px 0 4px 0",
  flexShrink: 0,
});

export const searchResultsListClass = mergeStyles({
  listStyle: "none",
  margin: 0,
  padding: "4px 0",
});

export const searchResultItemClass = mergeStyles({
  display: "flex",
  alignItems: "center",
  padding: "6px 12px",
  cursor: "pointer",
  gap: 8,
  outline: "none",
  ":hover": {
    backgroundColor: tokens.colorNeutralBackground2Hover,
  },
});

export const searchResultItemSelectedClass = mergeStyles({
  display: "flex",
  alignItems: "center",
  padding: "6px 12px",
  cursor: "pointer",
  gap: 8,
  outline: "none",
  backgroundColor: tokens.colorNeutralBackground2Selected,
});

export const searchResultTextClass = mergeStyles({
  display: "flex",
  flexDirection: "column",
  minWidth: 0,
});

export const searchResultNameClass = mergeStyles({
  fontWeight: tokens.fontWeightSemibold,
  fontSize: tokens.fontSizeBase300,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const searchTooltipContentClass = mergeStyles({
  whiteSpace: "normal",
  wordBreak: "keep-all",
});

export const searchTooltipSegmentClass = mergeStyles({
  whiteSpace: "nowrap",
});

export const searchResultPathClass = mergeStyles({
  fontSize: tokens.fontSizeBase200,
  color: tokens.colorNeutralForeground3,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const treeItemLayoutHighlightClass = mergeStyles({
  backgroundColor: `${tokens.colorNeutralBackground1Hover} !important`,
});

export const newFolderInputClass = mergeStyles({
  width: "100%",
});

export const newFolderErrorClass = mergeStyles({
  color: tokens.colorPaletteRedForeground1,
  fontSize: tokens.fontSizeBase200,
  marginTop: tokens.spacingVerticalXS,
});
